export const productRows = [
  {
    id: "1",
    image: "Part",
    sku: "JUKI-1004",
    name: "Juki genuine bobbin case",
    brandLine: "Juki",
    price: 10,
    stock: 84,
    status: "active",
    channels: ["facebook_marketplace", "ebay", "bobbinusa"],
    supplier: "Juki Genuine Parts",
    velocity: 34,
  },
  {
    id: "2",
    image: "Part",
    sku: "PEG-2072",
    name: "Needle plate assembly",
    brandLine: "Pegasus",
    price: 92.5,
    stock: 12,
    status: "active",
    channels: ["facebook_marketplace", "bobbinusa"],
    supplier: "Pegasus Direct",
    velocity: 18,
  },
  {
    id: "3",
    image: "Part",
    sku: "SNG-3320",
    name: "Thread tension spring",
    brandLine: "Singer",
    price: 18.95,
    stock: 0,
    status: "inactive",
    channels: ["ebay"],
    supplier: "Warehouse Stock",
    velocity: 8,
  },
  {
    id: "4",
    image: "Part",
    sku: "JUKI-4188",
    name: "Juki hook drive gear",
    brandLine: "Juki",
    price: 31,
    stock: 7,
    status: "active",
    channels: ["facebook_marketplace", "ebay"],
    supplier: "Juki Genuine Parts",
    velocity: 22,
  },
];

export const channelRows = [
  {
    name: "facebook_marketplace",
    label: "Facebook market place",
    status: "Disconnected",
    listings: 520,
    orders30d: 142,
    sales30d: 18420,
    failedJobs: 0,
  },
  {
    name: "ebay",
    label: "eBay",
    status: "Disconnected",
    listings: 480,
    orders30d: 96,
    sales30d: 12880,
    failedJobs: 0,
  },
  {
    name: "walmart",
    label: "Walmart",
    status: "Disconnected",
    listings: 0,
    orders30d: 0,
    sales30d: 0,
    failedJobs: 0,
  },
  {
    name: "bobbinusa",
    label: "Bobbin USA Store",
    status: "Connected",
    listings: 1320,
    orders30d: 218,
    sales30d: 28600,
    failedJobs: 0,
  },
];

export const shippingRules = [
  {
    name: "US Free Shipping",
    destinationCountry: "US",
    service: "Free",
    carrier: "Best available",
    weight: "Any",
    cost: "$0.00",
    priority: "Primary",
  },
  {
    name: "Canada Ground 1-3 lb",
    destinationCountry: "CA",
    service: "Ground",
    carrier: "UPS/FedEx Ground",
    weight: "1-3 lb",
    cost: "$30.00",
    priority: "Standard",
  },
  {
    name: "Canada Express 1-3 lb",
    destinationCountry: "CA",
    service: "Express",
    carrier: "UPS/FedEx Express",
    weight: "1-3 lb",
    cost: "$60.00",
    priority: "Fast",
  },
];

export const orderRows = [
  ["#10482", "New", "Paid", "Ready to pack", "Miller Sewing Co.", "$248.00"],
  ["#10481", "Processing", "Paid", "Tracking needed", "Stitch Works", "$92.50"],
  ["#10480", "Processing", "Held", "Address issue", "Ace Repair Shop", "$381.20"],
  ["#10479", "Shipped", "Paid", "UPS Ground", "Northline Textiles", "$146.75"],
];
